"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { ForumCategoryWithStats } from "@/lib/types";
import { formatDateTimeShort } from "@/lib/format";
import { NextLink } from "@/components/ui/next-link";

type Props = {
  categories: ForumCategoryWithStats[];
};

export function ForumCategoryList({ categories }: Props) {
  const formatDate = (date: Date | null) => (date ? formatDateTimeShort(date) : "–");

  return (
    <div className="p-0">
      <h1 className="text-2xl font-bold">Forum</h1>
      <Card className="p-0">
        <CardContent className="p-0">
          <Table className="">
            <TableHeader>
              <TableRow>
                <TableHead className="w-1/2 pl-4">Kategorie</TableHead>
                <TableHead className="w-1/6 text-center">Themen</TableHead>
                <TableHead className="w-1/6 text-center">Beiträge</TableHead>
                <TableHead className="w-1/4">Letzte Aktivität</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {categories.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} className="text-center text-muted-foreground py-8">
                    Keine Kategorien vorhanden.
                  </TableCell>
                </TableRow>
              )}
              {categories.map((cat) => (
                <TableRow key={cat.category_id}>
                  <TableCell className="pl-4 py-3 relative">
                    <NextLink href={`/home/forum/${cat.category_id}`} className="font-medium after:absolute after:inset-0">
                      {cat.category_name}
                    </NextLink>
                  </TableCell>
                  <TableCell className="text-center">{cat.thread_count}</TableCell>
                  <TableCell className="text-center">{cat.comment_count}</TableCell>
                  <TableCell className="text-muted-foreground text-sm">{formatDate(cat.last_activity)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
